import apiCall from '../utils/api';

export const retainerFormSubmit = async (data) => {
  const url = `/ims/v1/retainer/order`;
  const apiArgs = {
    API_CALL: {
      method: 'POST',
      data
    },
    url,
    extraPayload: {
      errorResponseRequired: true
    }
  };
  const res = await apiCall(apiArgs);
  return res;
};

export const getProductId = async () => {
  const url = `/ims/v1/retainer`;
  const apiArgs = {
    API_CALL: {
      method: 'GET'
    },
    url,
    contentType: 'application/json'
  };
  const res = await apiCall(apiArgs);
  return res;
};
